import clsx from "clsx";

interface Props {
  imageUrl: string;
  alt: string;
  className?: string;
}

export function CardDetailedModalImage({ imageUrl, alt, className }: Props) {
  return (
    <img
      src={imageUrl}
      alt={alt}
      className={clsx(
        "w-full rounded-lg shadow-lg aspect-[63/88] object-cover",
        className,
      )}
      width={300}
      height={423}
      onError={(e) => {
        const target = e.target as HTMLImageElement;
        target.src = "/placeholder.svg";
      }}
    />
  );
}
